"use strict";
/* tslint:disable:no-unsafe-any strict-type-predicates */
Object.defineProperty(exports, "__esModule", { value: true });
var matchesFactory = function () {
    var context = typeof Element !== "undefined" ? Element.prototype : window;
    var matches_selector = context.matches ||
        context.matchesSelector ||
        context.mozMatchesSelector ||
        context.msMatchesSelector ||
        context.oMatchesSelector ||
        context.webkitMatchesSelector;
    return function (element, selector) {
        return matches_selector.call(element, selector);
    };
};
exports.matches = matchesFactory();
